import './App.css';
import Router from './route/route';

function App() {
  return (
    <>
      <Router></Router>
    </>
  );
}

export default App;
